let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("gS9ZH")).then(() => parcelRequire('4wDKK'));